import * as CompanyEmailValidator from 'company-email-validator';

/**
 * Checks if the email is from a company domain
 * @param email The email to validate
 * @returns True if email is a company email, false if it's a personal/free email
 */
export const isCompanyEmail = (email: string): boolean => {
  if (!email || typeof email !== 'string') {
    return false;
  }
  
  return CompanyEmailValidator.isCompanyEmail(email);
};

/**
 * Checks if the email is from a free/personal email provider
 * @param email The email to validate
 * @returns True if email is a personal/free email, false if it's a company email
 */
export const isPersonalEmail = (email: string): boolean => {
  if (!email || typeof email !== 'string') {
    //console.log('[EMAIL-VALIDATOR] Invalid email input:', email);
    return false;
  }
  
  const result = !CompanyEmailValidator.isCompanyEmail(email);
  //console.log(`[EMAIL-VALIDATOR] Checking if ${email} is personal:`, result);
  return result;
}; 